import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'

const WoGLazy = createLazyComponent(() => import('./WoG'))

const WoG = (props) => <WoGLazy {...props} />

export default WoG
